export const Nobles = {
  AthletesNoble: require('./AthletesNoble'),
  EventsNoble: require('./EventsNoble'),
  MediaNoble: require('./MediaNoble'),
  RacesNoble: require('./RacesNoble'),
  ResultsNoble: require('./ResultsNoble'),
  WeatherNoble: require('./WeatherNoble'),
};



/** WEBPACK FOOTER **
 ** ./lib/anuket/nobles/index.js
 **/